import React, { useEffect, useState } from "react";
import Map, { Source, Layer, Marker, Popup, NavigationControl } from "react-map-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import axios from "axios";
import { URL_BASE } from "../../config/url-server";
import { Divider, Spin } from "antd";
import config from "../../config/config"; // Aquí debe estar tu token de Mapbox
import { Link } from "react-router-dom";
import { es } from "date-fns/locale/es";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import reportServices from "../../services/report-services";

import farmService from "../../services/farm-service";
import sectionService from "../../services/section-service";
import lotService from "../../services/lot-service";

import { ToastContainer, toast } from 'react-toastify';
import DatePicker from "react-datepicker";

import moment from "moment";

import { useForm } from "react-hook-form";

const LotMapInventory = () => {

    const [title, setTitle] = useState("Finca - Lote");

    const [viewState, setViewState] = useState({
        latitude: 5.391078, // Se actualizará dinámicamente
        longitude: -73.869958, // Se actualizará dinámicamente
        zoom: 5, // Zoom inicial
    });


    const [lotId, setLotId] = useState("0");
    const [farmId, setFarmId] = useState("0");
    const [selectedPoint, setSelectedPoint] = useState(null); // Punto seleccionado para el popup
    const [lotPalmsLayer, setLotPalmsLayer] = useState(null);
    const [mapLoaded, setMapLoaded] = useState(false);
    const [centerMap, setCenterMap] = useState({ lat: 10.5582, lng: -74.1915 });
    const [markerData, setMarkerData] = useState([]);
    const [popupInfo, setPopupInfo] = useState(null);
    const [loading, setLoading] = useState(false);

    const [tileset, setTileset] = useState(null);

    const clientId = localStorage.getItem("client");
    const accessToken = localStorage.getItem("token");

    const color_0="#ffffff"
    const color_1_5 = "#d8eea5"; 
    const color_6_11 = "#84e685"; 
    const color_12_17 = "#2aa34e"; 
    const color_18_22 = "#FD8D3C"; 
    const color_23 = "#E31A1C"; 



    const [showTable, setShowTable] = useState(false);
    const [palms, setPalms] = useState(0);
    const [totalFirstApplications, setTotalFirstApplications] = useState(0);
    const [initialDate, setInitialDate] = useState("");




    registerLocale("es", es);
    const start_date = moment().add(-config.DAYS_LESS_MAP, 'd').startOf("day").toDate();
    const end_date = moment().endOf("day").toDate();
    const [startDate, setStartDate] = useState(start_date);
    const [endDate, setEndDate] = useState(end_date);

    const [lotPalms, setLotPalms] = useState([]); // Puntos de todas las palmas del lote    
    const escoja = [{ _id: 0, name: "-ESCOJA-" }];
    const [listSection, setListSection] = useState(escoja);
    const [listFarms, setListFarms] = useState(escoja);
    const [listLots, setListLots] = useState(escoja);
    const [listUsers, setListUsers] = useState(escoja);






    const {
        register,
        getValues,
        setValue,
        formState: { errors },
    } = useForm();


    const getLisFarm = async () => {
        if (farmId == "0") {
            let listado = await farmService.getList();
            if (listado) {
                listado.push({ _id: 0, name: "-ESCOJA-" });
                const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
                setListFarms(sortedItems);
                //setValue("farm",0)
            }
        }
    };




    const getListSection = async (e) => {
        const code = e.target.value;
        if (code == "0") {
            setListSection(escoja);
            setListLots(escoja);
            setValue("section", "0")
            setValue("lot", "0")
            setValue("user", "0")
            return;
        }
        let listado = await sectionService.getListByFarm(code);
        listado.push({ _id: 0, name: "-ESCOJA-" });
        if (listado) {
            const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
            setListSection(sortedItems);
            setValue("section", "0")
            setValue("lot", "0")
            setValue("user", "0")
        }
    };



    const getLisLots = async (e) => {
        const code = e.target.value;
        if (code == "0") {
            setListLots(escoja);
            setValue("lot", "0")
            setValue("user", "0")
            return;
        }
        let listado = await lotService.getListBySection(code);
        listado.push({ _id: 0, name: "-ESCOJA-" });
        if (listado) {
            const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
            setListLots(sortedItems);
            setValue("lot", "0")
            setValue("user", "0")
        }
    };




    const generateExcel = async () => {

        const lotId = getValues("lot");


        if (lotId == "0") {
            toast.error("Debe seleccionar un lote!", { autoClose: 1800 })
            return
        }

        const days = getValues("days");
        const params = { lotId, days };

        setLoading(true);
        try {
            const response = await reportServices.fruitInventoryExcel(lotId, days);

            if (response?.error) {
                toast.error("No hay registros", { autoClose: 1600 })
                setLoading(false);
                return;
            }


            const url = window.URL.createObjectURL(new Blob([response]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `Inventario de inflorescencias.xlsx`);
            document.body.appendChild(link);
            link.click();
            link.remove();

        } catch (error) {
            setLoading(false);
        } finally {
            setLoading(false);
        }
    }











    const loadLotPositions = async () => {
        try {
            setShowTable(false)
            const lotId = getValues("lot");


            if (lotId == "0") {
                toast.error("Debe seleccionar un lote!", { autoClose: 1800 })
                return
            }

            const days = getValues("days");
            const params = { lotId, days };
            const configAxios = {
                headers: {
                    client: clientId,
                    Authorization: `Bearer ${accessToken}`,
                },
                params,
            };

            const response = await axios.get(URL_BASE + "map/map-lot-inventory", configAxios);
            const palms = response.data.data;


            const tilesetWeb = response.data.tileset;
            setTileset(tilesetWeb)

            const palmsPlantedWeb = response.data.palmsPlanted;
            setPalms(palmsPlantedWeb)


            const initialDateWeb = formatDate(response.data.initialDate);
            setInitialDate(initialDateWeb)



            if (palms.length > 0) {
                const middle = Math.floor(palms.length / 2);
                const coords = palms[middle]?.location?.coordinates;

                if (coords && coords.length === 2) {
                    const lat = coords[1];
                    const lng = coords[0];
                    setCenterMap({ lat, lng });

                    setViewState({
                        latitude: lat,
                        longitude: lng,
                        zoom: 18,
                    });
                }


            }

            setMarkerData(palms);





            let counter = 0;

            const filterCoord = palms.map((location, index) => {

                counter = counter + location.totalFirstApplications
                console.log(counter)

                const [lng, lat] = location.location.coordinates;

                const value = location.totalFirstApplications;
                const name = `${value}`;

                // Determinar el color según el valor
                let backgroundColor = color_0;
                let colorLabel = "#000";
                if (value >= 1 && value <= 5) {
                    backgroundColor = color_1_5; // Amarillo claro
                } else if (value >= 6 && value <= 11) {
                    backgroundColor = color_6_11;
                } else if (value >= 12 && value <= 17) {
                    backgroundColor = color_12_17;
                } else if (value >= 18 && value <= 22) {
                    backgroundColor = color_18_22;
                } else if (value >=23) {
                    backgroundColor = color_23;
                    colorLabel = "#000";
                }

                return (
                    <Marker
                        key={`lot-palm-${index}`}
                        longitude={lng}
                        latitude={lat}
                        anchor="center"
                    >
                        <div
                            onClick={() => setSelectedPoint(location)}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                backgroundColor: backgroundColor,
                                border: `1px solid #000`,
                                padding: "2px 2px",
                                borderRadius: "8px",
                                cursor: "pointer",
                                width: "21px",
                                height: "21px",
                                fontSize: "11px",
                                color: colorLabel,
                                fontWeight: "bold",
                                whiteSpace: "nowrap",
                            }}
                            title={name}
                        >
                            {name}
                        </div>
                    </Marker>
                );
            });



            setTotalFirstApplications(counter)
            setLotPalmsLayer(filterCoord)
            setShowTable(true)





        } catch (error) {
            console.error("Error obteniendo las palmas:", error);
        } finally {
            setLoading(false);
        }
    };


    const isValidCoordinate = (coord) => {


        return (
            Array.isArray(coord) &&
            coord.length === 2 &&
            typeof coord[0] === 'number' &&
            typeof coord[1] === 'number' &&
            !isNaN(coord[0]) &&
            !isNaN(coord[1])
        );
    };


    const formatDate = (dateString) => {
        return moment(dateString).locale('es').format('DD MMM');
    };


    useEffect(() => {
        const farm_name = localStorage.getItem("farmName");
        const lot_name = localStorage.getItem("lotName");
        setTitle(`FINCA ${farm_name} - ${lot_name}`);
        getLisFarm();
        setValue("days", 190);
        // loadLotPositions();
    }, []);

    return (
        <div >

            <ToastContainer />





            <div className="row">


                <div className="col-12 col-sm-2">

                    <div className="col-12 ml-4 ms-2" style={{ marginTop: "-10px" }}>
                        <Divider orientation="left" style={{ border: "#AAAAAA" }} >Inventario de fruta</Divider>
                    </div>

                    <form className="form-react">
                        <div className="row ms-2">




                            <div className=" col-12">
                                <label className="text-secondary fw-bold">Finca</label>
                                <select
                                    className="form-control text-secondary"

                                    {...register("farm")}
                                    onChange={(e) => getListSection(e)}
                                >
                                    {listFarms.map((option) => (
                                        <option key={option._id} value={option._id}>
                                            {option.name}
                                        </option>
                                    ))}
                                </select>
                            </div>


                            <div className="  col-12 col-sm-12">
                                <label className="text-secondary fw-bold">Sección</label>
                                <select
                                    className="form-control text-secondary"
                                    {...register("section")}
                                    {...register("section")}
                                    onChange={(e) => getLisLots(e)}
                                >
                                    {listSection.map((option) => (
                                        <option key={option._id} value={option._id}>
                                            {option.name}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className=" col-12">
                                <label className="text-secondary fw-bold">Lote</label>
                                <select
                                    className="form-control text-secondary"
                                    {...register("lot")}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setLotId(value);
                                    }}
                                >
                                    {listLots.map((option) => (
                                        <option key={option._id} value={option._id}>
                                            {option.name}
                                        </option>
                                    ))}
                                </select>
                            </div>






                            <div className=" col-12">
                                <label className="text-secondary fw-bold">Días</label>
                                <br />
                                <input
                                    type="number"
                                    className="form-control"
                                    {...register("days")}
                                />
                            </div>






                            <div className=" col-12">
                                <label className="text-secondary fw-bold">&nbsp;</label>
                                <br />
                                <Spin spinning={loading}>
                                    <button
                                        className="btn btn-primary w-100"
                                        type="button"
                                        onClick={() => loadLotPositions()}
                                    >
                                        <i className="bi bi-search fa-lg m-2" /> Buscar
                                    </button>

                                </Spin>

                            </div>


                            <div className=" col-12 mb-4">
                                <label className="text-secondary fw-bold">&nbsp;</label>
                                <br />
                                <Spin spinning={loading}>
                                    <button
                                        className="btn btn-info w-100"
                                        type="button"
                                        onClick={() => generateExcel()}
                                    >
                                        <i className="bi bi-file-earmark-text fa-lg m-2" /> Exportar
                                    </button>
                                </Spin>
                            </div>




                        </div>
                    </form>





                    <div className="col-12 m-3">

                        <h6 style={{ fontWeight: "bold", marginBottom: "8px" }}>Leyenda de colores</h6>
                        <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                <span style={{ width: "20px", height: "20px", backgroundColor: color_0, border: "1px solid #aaa", borderRadius: "4px" }}></span>
                                <span>0 racimos</span>
                            </div>
                            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                <span style={{ width: "20px", height: "20px", backgroundColor: color_1_5, border: "1px solid #aaa", borderRadius: "4px" }}></span>
                                <span>1 a 5 racimos</span>
                            </div>
                            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                <span style={{ width: "20px", height: "20px", backgroundColor: color_6_11, border: "1px solid #aaa", borderRadius: "4px" }}></span>
                                <span>6 a 11 racimos</span>
                            </div>
                            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                <span style={{ width: "20px", height: "20px", backgroundColor: color_12_17, border: "1px solid #aaa", borderRadius: "4px" }}></span>
                                <span>12 a 17 racimos</span>
                            </div>
                            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                <span style={{ width: "20px", height: "20px", backgroundColor: color_18_22, border: "1px solid #aaa", borderRadius: "4px" }}></span>
                                <span>18 a 22 racimos</span>
                            </div>
                            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                <span style={{ width: "20px", height: "20px", backgroundColor: color_23, border: "1px solid #aaa", borderRadius: "4px" }}></span>
                                <span>23 o más racimos</span>
                            </div>
                        </div>

                    </div>

                    <div className={showTable ? "col-12 ms-2 p-2" : "d-none"}>
                        <table className="table table-bordered table-striped table-hover table-sm text-center">

                            <tbody>


                                <tr className="table-primary">
                                    <td colSpan={2}><b>Desde {initialDate}</b></td>
                                </tr>

                                <tr>
                                    <td><b>Palmas</b></td>
                                    <td>{palms.toLocaleString()}</td>
                                </tr>

                                <tr>
                                    <td><b>Racimos</b></td>
                                    <td>{totalFirstApplications.toLocaleString()}</td>
                                </tr>
                            </tbody>


                        </table>
                    </div>






                </div>



                <div className="col-12 col-sm-10">
                    <Map
                        {...viewState} // Aplicar el estado de la vista dinámica
                        onMove={evt => setViewState(evt.viewState)} // Permitir mover el mapa
                        style={{ width: "100%", height: "100vh" }}
                        mapStyle="mapbox://styles/mapbox/satellite-v9" // Mapa satelital
                        mapboxAccessToken="pk.eyJ1IjoianVhbmNwaW5lZGFtIiwiYSI6ImNtNXlyNmxtbjBubm0ya3B5ZHVnMWgwcWYifQ.dogzl3DX9PMO9QywZ8CbyA"
                    >

                        <NavigationControl position="top-left" />

                        {lotPalmsLayer}

                        {selectedPoint && selectedPoint.location?.coordinates && (
                            <Popup
                                longitude={selectedPoint.location.coordinates[0]}
                                latitude={selectedPoint.location.coordinates[1]}
                                onClose={() => setSelectedPoint(null)}
                                closeOnClick={false}
                            >
                                <div>

                                    <p className="text-success" ><strong>Linea-Palma</strong></p>
                                    <strong>Línea:</strong> {selectedPoint.lineName || "N/A"}<br />
                                    <strong>Palma:</strong> {selectedPoint.palmName || "N/A"}
                                </div>
                            </Popup>
                        )}


                        {tileset && (
                            <>
                                <Source
                                    id="ortomosaico"
                                    type="raster"
                                    url={`mapbox://${tileset}`}
                                    tileSize={256}
                                />
                                <Layer
                                    id="ortomosaico-layer"
                                    type="raster"
                                    source="ortomosaico"
                                    paint={{ "raster-opacity": 1 }}
                                />
                            </>
                        )}

                    </Map>

                </div>



            </div>




        </div>
    );
};

export default LotMapInventory;
